<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
        <div class="container">

            <div class="form-group" style="margin-top: 30px">
                <router-link to="/userManager" class="btn btn-default">{{ $t('Back') }}</router-link>
            </div>

            <div class="panel panel-default">
                <div class="panel-heading">{{ $t('Add') }}</div>
                <div class="panel-body">
                    <form v-on:submit.prevent="saveForm()">

          

                         <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Name') }} {{ $t('surname') }}</label>
                                <input class="form-control"  type="text"  v-model="item.name" >
                                 
                            </div>
                        </div>


                         <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('phone') }}</label>
                                <input class="form-control"  type="text" v-model="item.mobile">
                         
                            </div>
                        </div>
                          <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('password') }}</label>
                                <input class="form-control"  type="password" v-model="item.password">
                         
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('e-mail') }}</label>
                             <input class="form-control" type="text" required v-model="item.email">
                            </div>
                        </div>
                  
                       

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <button class="btn btn-success">{{ $t('Add') }}</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }

    };

    export default {
        data: function () {
            return {
                auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
                item: {
                name:'',
                mobile:'',
                password:'',
                email:''
                // name:''
                },

                errors: [],

                // product_categories: []

            }
        },

        mounted() {
            // axios
            //     .get('/api/productCategories', auth)
            //     .then(response => {
                    
            //         this.product_categories = response.data.data;

            //     })
            //     .catch(error => {
            //         console.log(error);
            //         this.errored = true
            //     })

        }


        ,

        methods: {
            saveForm() {
                var app = this;
                var newItem = app.item;
                // console.log(newItem)
                // console.log(app.auth)
                axios.post('/admin-api/v1/user/create', newItem, app.auth)
                    .then(function (resp) {
                        app.$router.push({
                            path: '/user/list'
                        });
                        
                        // console.log(resp);

                    })
                    .catch(
                        e => {
                           
                            app.errors.push(e.response.data.messages);
                        for (let value of e.response.data.messages_fa) {
//                        for (let error of Object.entries(value[1])) {
//                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,
//                                    showProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });

//                        }
                        }

                        }

                    );


            }
        }
    }

</script>
